import React from 'react';

interface ToastContentProps {
  title: string;
  message: string;
}

const ToastContent: React.FC<ToastContentProps> = ({ title, message }) => (
  <div>
    <strong>{title}</strong>
    <div>{message}</div>
  </div>
);

export default ToastContent;
